
import { Prop, Vue, Component, Watch } from 'vue-property-decorator';
import BaseCheckbox from './ui/BaseCheckbox.vue';

interface FilterItem {
    name: string;
    count: number;
}

@Component({
    components: { BaseCheckbox }
})
export default class SizeFilter extends Vue {
    @Prop({ required: true }) readonly sizes!: FilterItem[];
    @Prop({ required: true }) readonly value!: string[];

    selectedSizes: string[] = this.value;

    @Watch('value')
    onValueChange(newValue: string[]): void {
        this.selectedSizes = newValue;
    }

    emitChange(): void {
        this.$emit('input', this.selectedSizes);
    }

    onSizeChange(sizeName: string, event: Event): void {
        const target = event.target as HTMLInputElement;
        if (target) {
            this.toggleSize(sizeName, target.checked);
        }
    }

    private toggleSize(sizeName: string, checked: boolean): void {
        if (checked) {
            this.selectedSizes.push(sizeName);
        } else {
            const index = this.selectedSizes.indexOf(sizeName);
            if (index !== -1) {
                this.selectedSizes.splice(index, 1);
            }
        }
        this.emitChange();
    }
}
